import { render, staticRenderFns } from "./C-3-1b-9__ProductInfoEdit_LandingPageURL__ProductSpec.vue?vue&type=template&id=b2ee863e&"
import script from "./C-3-1b-9__ProductInfoEdit_LandingPageURL__ProductSpec.vue?vue&type=script&lang=js&"
export * from "./C-3-1b-9__ProductInfoEdit_LandingPageURL__ProductSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
